import styled from "styled-components";
import { FooterWrap } from "../../component/common";

export const Rop01FooterWrap = styled(FooterWrap)`
  > section {
    background: #fff;
    color: black;
  }
`